module.exports = __webpack_public_path__ + "images/common_icon_down.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/common_icon_down.png
// module id = 844
// module chunks = 121